<template>
  <div id="app">
    <!-- <div class="important-notice">重要通知：本系统将于2026年1月5号0点停用，届时系统将无法登录。请合理安排广告排期和数据归档处理等事宜！</div> -->
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
import enquireScreen from './utils/device'
export default {
  name: 'App',
  data () {
    return {}
  },
  created () {
    let _this = this
    enquireScreen(isMobile => {
      _this.$store.commit('setting/setDevice', isMobile)
    })
  }
}
</script>

<style lang="less">
  :global{
    //拖拽控件全局样式
    .dragable-ghost{
      border: 1px dashed #aaaaaa;
      opacity: 0.65;
    }
    .dragable-chose{
      border: 1px dashed #aaaaaa;
      opacity: 0.65;
    }
    .dragable-drag{
      border: 1px dashed #aaaaaa;
      opacity: 0.65;
    }
    //页面切换动画
    .page-toggle-enter-active{
      transition: all 0.2s ease-in 0.25s;
    }
    .page-toggle-leave-active{
      transition: all 0.2s ease-out 0s;
    }
    .page-toggle-enter, .page-toggle-leave-to{
      opacity: 0;
      padding: 0px;
    }
  }
  // .important-notice{
  //   width: 100%;
  //   height: 36px;
  //   line-height: 30px;
  //   background-color: #fff2e8;
  //   color: #fa541c;
  //   text-align: center;
  //   font-size: 18px;
  //   line-height: 36px;
  // }
</style>



// WEBPACK FOOTER //
// src/App.vue